import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, QueryList, ViewChildren } from "@angular/core";
import { InvoiceService } from "../invoice.service";
import { AccountService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "order-invoice",
  templateUrl: "./invoice.component.html",
  styleUrls: ["./invoice.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderInvoiceComponent implements AfterViewInit, OnDestroy {
  @ViewChildren(`factorss`) things: QueryList<any>;
  destroy$ = new Subject();

  constructor(
    private cd: ChangeDetectorRef,
    public invoiceservice: InvoiceService,
    public accountService: AccountService,
    private translate: TranslateService
  ) {
    this.invoiceservice.order.cd_Invoice = this.cd;
  }

  ngAfterViewInit() {
    this.things.changes.pipe(takeUntil(this.destroy$)).subscribe((t) => {
      this.scrollToItem();
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
  }

  scrollToItem() {
    const order = this.invoiceservice.order;
    if (!order.selectedInvoiceItem || order.selectedInvoiceItem?.Quantity > 1) return;
    var el = document.getElementById(`factor${order.invoice.SaleMethodBranchId}`);
    let item = document.getElementById(order.selectedInvoiceItem.Index.toString());
    this.scrollParentToChild(el, item);
  }
  scrollParentToChild(parent, child) {
    // Where is the parent on page
    var parentRect = parent?.getBoundingClientRect();
    // What can you see?
    var parentViewableArea = {
      height: parent?.clientHeight,
      width: parent?.clientWidth,
    };

    // Where is the child
    var childRect = child?.getBoundingClientRect();
    // Is the child viewable?
    var isViewable = childRect?.top >= parentRect?.top && childRect?.bottom <= parentRect?.top + parentViewableArea?.height;

    // if you can't see the child try to scroll parent
    if (!isViewable) {
      // Should we scroll using top or bottom? Find the smaller ABS adjustment
      const scrollTop = childRect?.top - parentRect?.top;
      const scrollBot = childRect?.bottom - parentRect?.bottom;
      if (parent && Math.abs(scrollTop) < Math.abs(scrollBot)) {
        // we're near the top of the list
        parent.scrollTop += scrollTop;
      } else if (parent) {
        // we're near the bottom of the list
        parent.scrollTop += scrollBot;
      }
    }
  }

  afterChangeBranchFromView(id: number) {
    const order = this.invoiceservice.order;
    const isActiveCategory = order.customerInActiveCategory(order.invoice?.AddressId, order.invoice?.Customer, id);
    if (isActiveCategory) {
      order.invoice.BranchId = id;
      order.sts?.showDialog(
        `${this.translate.instant("ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.AllowedPlaceOrderSelectedCustomerGroupBranch")}`,
        this.translate.instant("ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.ErrorMessage")
      );
      return;
    }
    // find minutes to delivery from related zone branch
    if (order.invoice?.Customer) {
      order.invoice.Customer.MinutesToDelivery = order.invoice.CustomerAddress?.Zone?.Branches?.find((x) => x.BranchId === id)?.MinutesToDelivery;
      order.defaultMinutesToDelivery = order.invoice.Customer.MinutesToDelivery;
    }
    order.ChangeBranch(id);
    order.clearAllAdditivesAndDescriptions();
    order.checkActivationOfInvoiceItem();
    order.setShippingCost(id);
    this.invoiceservice.checkDescription();
  }
}
